import React, { useEffect, useState } from "react";
import Container from "../../common/Container";
import Collapsable from "../../common/Collapsable";
import { Form, FormikProvider, useFormik } from "formik";
import TyreDetails from "./view/TyreDetails/TyreDetails";
import ProposedVehicles from "./view/ProposedVehciles/ProposedVehicles";
import CallbackRequirements from "./view/CallbackRequirements/CallbackRequirement";
import DocumentUpload from "./view/DocumentUpload";
import TestRequirement from "./view/TestRequirement";
import Button from "../../common/Button";
import { deleteDocumentById, getAllData, updateDocumentByID } from "../../apis/customApiHandler";
import DownloadTestPlan from "./DownloadTestPlan";
import { convertToIndianTimezone, convertToIndianTimezoneAndGetDate, titleCase } from "../../utils/helpers";
import { createSearchParams, useNavigate, useSearchParams } from "react-router-dom";
import { LoaderIcon } from "react-hot-toast";
import { LinearProgress } from "@mui/material";
import FitmentDetails from "./view/FitmentDetails";
import DiscountDetails from "./view/DiscountDetails";
import checkPermission from "../../utils/checkPermission";
import Modal from "../../common/Modal"


function ViewTestPlan({  }) {
  const [view, setView] = useState(false)
  const [data, setData] = useState({});
  const [disabled, setDisabled] = useState(true);
  const [modifyDisabled, setModifyDisabled] = useState(false);
  const [expanded, setExpanded] = useState(5);
  const currentUser = JSON.parse(localStorage.getItem("user"))
  const [searchParams, setSearchParams] = useSearchParams();
  const mode = searchParams.get("mode")
  const [planNo, setPlanNo] = useState()
  const [allowEdit, setAllowEdit] = useState(false)
  const [action, setAction] = useState(null)
  const navigate = useNavigate();


  const [statuses, setStatuses] = useState({
    0: 2, 1: 2, 2: 2, 3: 2, 4: 2, 5: 2
  });

  const handleChangeWindow = (panel) => (event, newExpanded) => {
    if (newExpanded) {
      if (panel !== 0) {
        if (statuses[panel - 1] !== 2) return;
      }
    }
    setExpanded(newExpanded ? panel : false);
    setStatuses({ ...statuses, [panel]: statuses[panel] === 2 ? 2 : 1 });

  };
  useEffect(()=>{
    setPlanNo(searchParams.get("planNo"))
    setAllowEdit(["APPROVED", "ACCEPTED", "REJECTED", "ASKED FOR MODIFICATION", "ASK_FOR_MODIFICATION"].includes(searchParams.get("mode")))
  }, [searchParams])
  


  const getTestPlan = async()=>{
    console.log("FETCHING SINGLE REQUEST")
    const response = await getAllData("/test_plan", {planNo});
    if(response.data?.length){
      setData(response.data[0])
      formik.setValues(response.data[0])
    }
  }

  
  useEffect(()=>{
    console.log({planNo})
    if(planNo) getTestPlan();
  }, [planNo])


  const formik = useFormik({
    initialValues: data,
    onSubmit: async (values) => {
      console.log({ values });
    },

    validate: (values) => {
      let errors = {};
      if (!values.testRequirements) errors.testRequirements = "Required";
      if (!values.password) errors.password = "Required";
      return errors;
    },
  });
  console.log(data?.status === "APPROVED", ((currentUser.role.name == 'PDC Head' || currentUser.role.name === 'PTG Head') === false),  data.nextActionBy !== currentUser.role.name )

  // console.log(formik.values)

  const sections = [
    {
      title: "Test Requirement",
      name: "testRequirement",
      content: (
        <TestRequirement
          index={0}
          name="testRequirement"
          totalSteps={5}
          formik={formik}
          disabled={disabled}
          setDisabled={setDisabled}
          expanded={expanded}
          setExpanded={setExpanded}
          allowEdit={allowEdit}
          remarksTimeline = {data?.remarksTimeline?.testRequirement}
          handleSubmit={(values) =>{
            console.log({values});
            formik.setFieldValue("remarksTimeline", { ...formik.values.remarksTimeline, "testRequirement": values })
            console.log(formik.values.remarksTimeline)
          }}
          data={data?.testRequirement}
        />
      ),
      disabled: disabled,
      setDisabled: setDisabled,
    },
    {
      title: "Tyre Details",
      name: "tyreDetails",
      content: (
        <TyreDetails
          index={1}
          totalSteps={5}
          formik={formik}
          data={data?.tyreDetails}
          allowEdit={allowEdit}
          remarksTimeline = {data?.remarksTimeline?.testRequirement}
          handleSubmit={(values) =>{
            console.log({values});
            formik.setFieldValue("remarksTimeline", { ...formik.values.remarksTimeline, "tyreDetails": values })
            console.log(formik.values.remarksTimeline)
          }}
        />
      ),
      disabled: disabled,
      setDisabled: setDisabled,
    },
    {
      title: "Proposed Vehicles",
      name: "proposedVehicles",
      content: (
        <ProposedVehicles
          index={2}
          name="proposedVehicles"
          totalSteps={5}
          formik={formik}
          data={data?.proposedVehicles}
          allowEdit={allowEdit}
          remarksTimeline = {data?.remarksTimeline?.testRequirement}
          handleSubmit={(values) =>{
            console.log({values});
            formik.setFieldValue("remarksTimeline", { ...formik.values.remarksTimeline, "proposedVehicles": values })
            console.log(formik.values.remarksTimeline)
          }}
        />
      ),
      disabled: disabled,
      setDisabled: setDisabled,
    },
    {
      title: "Fitment Details",
      name: "fitmentDetails",
      content: (
        <FitmentDetails
          index={3}
          name="fitmentDetails"
          totalSteps={5}
          formik={formik}
          calculatedTyreDetails ={data?.calculatedTyreDetails}
          disabled={disabled}
          setDisabled={setDisabled}
          allowEdit={allowEdit}
          remarksTimeline = {data?.remarksTimeline?.testRequirement}
          handleSubmit={(values) =>{
            console.log({values});
            formik.setFieldValue("remarksTimeline", { ...formik.values.remarksTimeline, "fitmentDetails": values })
            console.log(formik.values.remarksTimeline)
          }}
          data={data?.fitmentDetails}
        />
      ),
      disabled: disabled,
      setDisabled: setDisabled,
    },
    {
      title: "Discount Details",
      name: "discountDetails",
      content: (
        <DiscountDetails
          index={4}
          name="discountDetails"
          totalSteps={5}
          formik={formik}
          calculatedTyreDetails ={data?.calculatedTyreDetails}
          disabled={disabled}
          setDisabled={setDisabled}
          allowEdit={allowEdit}
          remarksTimeline = {data?.remarksTimeline?.testRequirement}
          handleSubmit={(values) =>{
            console.log({values});
            formik.setFieldValue("remarksTimeline", { ...formik.values.remarksTimeline, "discountDetails": values })
            console.log(formik.values.remarksTimeline)
          }}
          data={data?.discountDetails}
        />
      ),
      disabled: disabled,
      setDisabled: setDisabled,
    },
    {
      title: "Documents",
      name: "documents",
      content: (
        <DocumentUpload
          index={5}
          name="documents"
          totalSteps={5}
          formik={formik}
          expanded={expanded}
          setExpanded={setExpanded}
          data={data?.documents}
          allowEdit={allowEdit}
          remarksTimeline = {data?.remarksTimeline?.testRequirement}
          handleSubmit={(values) =>{
            console.log({values});
            formik.setFieldValue("remarksTimeline", { ...formik.values.remarksTimeline, "documents": values })
            console.log(formik.values.remarksTimeline)
          }}

        />
      ),
      disabled: disabled,
      setDisabled: setDisabled,
    },
  ];

  // console.log("status", data.status)
  return (
    <Container cname="container_test_request">
      <div className="flex flex-col md:flex-row justify-between mb-10">
        <div className=" flex flex-col">
          <div className="font-semibold text-[24px] flex flex-row ">
            {(view) && (
              <span
                className="justify-start mr-2 cursor-pointer"
                onClick={() => {
                  setView(false);
                }}
              >
                <img src="/icons/back.svg" className="m-1 h-4 w-4 mt-3 "></img>
              </span>
            )}
            <span>View Details</span>
          </div>
          <div className="text-grey mt-1 font-semibold">({data.planNo})</div>
        </div>

        <div className="flex flex-row text-white gap-5 px-2 text-[14px] h-10">
          <div
            className={`${
              data.status?.toUpperCase() === "REJECTED"
                ? "text-red-500"
                : data.status?.toUpperCase() === "APPROVED" ||
                  data.status?.toUpperCase() === "ACCEPTED"
                ? "text-green-500"
                : data.status?.toUpperCase() === "ASKED FOR MODIFICATION"
                ? " text-orange-500"
                : "text-main"
            } text-md justify-center align-middle m-auto py-2 px-5 text-center font-medium rounded-md text-[16px] border border-2`}
          >
            {data.status?.toUpperCase() === "ACCEPTED"
            ? "Approved"
            : titleCase(data.status)}
          </div>
          {!view && (
            <button
            className={`  text-center text-white py-2 rounded w-36  ${data.status === "DRAFT" ? "bg-lightGrey" : "bg-blue-900 hover:shadow-lg hover:bg-mainLighter"}`}
            disabled={data.status === "DRAFT"}
            onClick={() => {
                setView(!view);
              }}
            >
              View as PDF{" "}
            </button>
          )}
        </div>
      </div>
      {view ? (
        <DownloadTestPlan planNo={planNo} />
      ) : formik.values?.testRequirement ? (
        <FormikProvider value={formik} className="">
          <Form>
            {sections.map((section, index) => {
              return (
                <Collapsable
                  expanded={expanded}
                  setExpanded={setExpanded}
                  statuses={statuses}
                  setStatuses={setStatuses}
                  section={section}
                  handleChangeWindow={handleChangeWindow}
                  formik={formik}
                  index={index}
                  totalSteps={5}
                />
              );
            })}
            {data.status === "ACCEPTED" ||
            data.status === "REJECTED" ? (
              <></>
            ) : (
              <div className="flex justify-between mt-6 text-md">
                <div className="flex flex-row gap-3  w-98">
                  {mode!== "REVIEW" && data.status!== "DRAFT" && checkPermission(
                    [
                      {
                        permission: "test_plans",
                        subPermission: ["REJECT"],
                      },
                    ],
                    currentUser
                  ) && (
                    <Button
                      type="button"
                      className="bg-danger text-white text-center items-center justify-center h-10 px-8"
                      onClick={async (e) => {
                        e.preventDefault();
                        const response = await updateDocumentByID(
                          "/test_plan",
                          data?._id,
                          {
                            ...formik.values,
                            status: "REJECTED",
                            action: "REJECT",
                            actionBy: currentUser.role.name,
                            nextAction: "",
                            nextActionBy: "",
                            updatedBy: currentUser?._id,
                          }
                        );
                        window.location.href = "/test-plans";
                      }}
                    >
                      Reject
                    </Button>
                  )}
                  {mode!== "REVIEW" && data.status!== "DRAFT" && checkPermission(
                    [
                      {
                        permission: "test_plans",
                        subPermission: ["ASK_FOR_MODIFICATION"],
                      },
                    ],
                    currentUser
                  ) && (
                    <Button
                      type="button"
                      // disabled={resetDisabled}
                      className="bg-white text-grey border border-2 border-grey text-center items-center justify-center h-10 px-6"
                      onClick={async () => {
                        // formik.setValues({ ...formik.values });
                        // const response = await updateDocumentByID(
                        //   "/test_plan",
                        //   data?._id,
                        //   {
                        //     ...formik.values,
                        //     status: "ASKED FOR MODIFICATION",
                        //     action: "ASKED FOR MODIFICATION",
                        //     updatedBy: currentUser?._id,
                        //     nextAction:
                        //       currentUser.role.name === "PDC Head"
                        //         ? "APPROVE"
                        //         : "ACCEPT",
                        //     nextActionBy: currentUser.role.name,
                        //   }
                        // );
                        // setDisabled(true);
                        // window.location.href = "/test-plans";
                        setAction({
                          type: "Ask for Modification",
                          status: "ASKED FOR MODIFICATION",
                        });
                      }}
                    >
                      Ask for Modification
                    </Button>
                  )}
                </div>
                <div className="flex flex-row gap-3  w-98">
                {mode!== "REVIEW" && data.status!== "DRAFT" && checkPermission(
                  [
                    {
                      permission: "test_plans",
                      subPermission: [data.nextAction],
                    },
                  ],
                  currentUser
                ) && (
                  // data.nextActionBy === currentUser.role.name &&
                  <Button
                    type="button"
                    // disabled={resetDisabled}
                    className="bg-main text-white text-center items-center justify-center h-10 px-6"
                    onClick={async () => {
                      const response = await updateDocumentByID(
                        "/test_plan",
                        data?._id,
                        {
                          ...formik.values,
                          ...(
                            // currentUser.role.name === "PTG Head" &&
                            !["ACCEPTED", "APPROVED"].includes(data.status) && {
                              status: "APPROVED",
                              action: "APPROVE",
                              actionBy: currentUser.role.name,
                              nextAction: "ACCEPT",
                              nextActionBy: "PTG Head",
                            }),
                          ...(
                            data.status === "APPROVED" &&
                            // currentUser.role.name === "PDC Head" &&
                           {
                            status: "ACCEPTED",
                            action: "ACCEPT",
                            actionBy: currentUser.role.name,
                            nextAction: "",
                            nextActionBy: "",
                          }),
                          updatedBy: currentUser?._id,
                        }
                      );
                      window.location.href = "/test-plans";
                    }}
                  >
                    Approve
                  </Button>
                )}

                {(checkPermission(
                          [
                            {
                              permission: "test_plans",
                              subPermission: ["CREATE", "UPDATE"],
                            },
                          ],
                          currentUser
                        ) && 
                  mode === "REVIEW") && (
                  <div className="flex justify-between text-md">
                    <div className="justify-end">
                      <Button
                        type="button"
                        // disabled={resetDisabled}
                        className="bg-main text-white text-center items-center justify-center h-10 px-6"
                        onClick={async () => {
                          // formik.setValues({ ...formik.values });
                          console.log(formik.values);
                          const response = await updateDocumentByID(
                            "/test_plan",
                            data?._id,
                            {
                              ...formik.values,
                              ...(formik.values.status === "DRAFT" && {
                                generateRequestNumber: true,
                              }),
                              updatedBy: currentUser?._id,
                              actionBy: currentUser.role.name,
                              submissionDate: formik.values.status === "DRAFT" ? new Date(new Date().getTime() + 330*60*1000): formik.values.submissionDate,
                              fitmentStatus: formik.values.status === "DRAFT"? "OPEN": formik.values.fitmentStatus,
                              status:
                                formik.values.nextActionBy === "PDC Head"
                                  ? "PENDING_ACCEPTANCE"
                                  : formik.values.status === "DRAFT" &&
                                    mode === "REVIEW"
                                  ? "SENT FOR APPROVAL"
                                  : formik.values.status === "ASKED FOR MODIFICATION" &&
                                    (mode === "EDIT" || mode === "REVIEW")
                                  ? "PENDING_APPROVAL"
                                  : formik.values.status === "SENT FOR APPROVAL"
                                  ? "SENT FOR APPROVAL"
                                  : mode !== "REVIEW"
                                  ? mode
                                  : "PENDING_APPROVAL",
                              action:
                                mode === "REVIEW"
                                  ? formik.values.status !== "DRAFT"
                                    ? "UPDATE"
                                    : "CREATE"
                                  : formik.values.action,
                            }
                          );
                          if (response?.data) {
                            // navigate("/test-requests")
                            window.location.href = "/test-plans";
                          }
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                )}
                </div>
              </div>
            )}

            {action && (
              <Modal
                handleClick={() => {
                  setAction(null);
                }}
                title={"Alert!"}
                showSubTitle={false}
                id="MODAL"
                className={` w-64 min-h-fit p-3 px-4`}
              >
                <p className="p-2 mb-2 flex mx-auto justify-center">
                  Please confirm it you want to {action.type} on this test
                  request
                </p>
                <div className= "w-24 mx-auto justify-center">
                <Button
                  className="m-2 flex mx-auto bg-main text-white text-center items-center justify-center h-10 px-6"
                  disabled={modifyDisabled}
                  onClick={async () => {
                    // formik.setValues({ ...formik.values });
                    setModifyDisabled(true);
                    try{
                    const response = await updateDocumentByID(
                      "/test_plan",
                      data?._id,
                      {
                        ...formik.values,
                        status: action.status,
                        action: action.status,
                        updatedBy: currentUser?._id,
                        nextAction:
                        checkPermission(
                          [
                            {
                              permission: "test_plans",
                              subPermission: ["ACCEPT"],
                            },
                          ],
                          currentUser
                        )
                            ? "APPROVE"
                            : "ACCEPT",
                        actionBy: currentUser.role.name,
                        nextActionBy: currentUser.role.name,
                      }
                    );
                    setDisabled(true);
                    window.location.href = "/test-plans";
                    }catch(err){

                    }finally{
                      setModifyDisabled(false);
                    }
                  }}
                >
                  Yes
                </Button>
                </div>
              </Modal>
            )}
          </Form>
        </FormikProvider>
      ) : (
        <LinearProgress color="secondary" />
      )}
    </Container>
  );
}

export default ViewTestPlan;
